import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import ResourceListPage from "@/pages/ResourceListPage";
import SupplierBillUpload from "@/pages/SupplierBillUpload";

// Purchase Bills module (desktop). Same shared backend / purchasing logic.
// OCR "Upload Bill" (supplier bill upload) folded in as a tab. No unintended stock posting.
export default function PurchaseBills() {
  const [tab, setTab] = useState("list");
  return (
    <Tabs value={tab} onValueChange={setTab} className="space-y-4">
      <TabsList data-testid="purchasebills-tabs" className="bg-stone-100">
        <TabsTrigger value="list" data-testid="purchasebills-tab-list">Purchase Bills</TabsTrigger>
        <TabsTrigger value="upload" data-testid="purchasebills-tab-upload">Upload Bill (OCR)</TabsTrigger>
      </TabsList>
      <TabsContent value="list"><ResourceListPage /></TabsContent>
      <TabsContent value="upload"><SupplierBillUpload /></TabsContent>
    </Tabs>
  );
}
